import type { FC } from 'react';
import { DialogTitle } from '@headlessui/react';
import { useLanguage } from '@root/src/language';

import { AttachmentUploadController } from '../controller/AttachmentUploadController';

import { AttachmentModal } from './AttachmentModal';

interface AttachmentUploadModalProps {
  handleClose: () => void;
}

export const AttachmentUploadModal: FC<AttachmentUploadModalProps> = ({ handleClose }) => {
  const { getContent } = useLanguage({ prefix: 'naming.mrc.modals.attachment' });

  return (
    <AttachmentModal handleClose={handleClose}>
      <>
        <DialogTitle as="h3" className="text-info-900! mb-2 text-xl! leading-6">
          {getContent(`title.create`)}
        </DialogTitle>
        <AttachmentUploadController handleClose={handleClose} />
      </>
    </AttachmentModal>
  );
};
